<template>
  <div class="page">
    <van-pull-refresh
      class="list-wrap"
      v-model="refreshing"
      @refresh="handleBookQuery(true)"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="暂无捐赠数据"
        @load="handleBookQuery"
        ref="bookList"
      >
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="text-wrap" v-if="item.title">
            <div
              class="tit all van-multi-ellipsis--l2"
              v-text="item.title"
            ></div>
          </div>
          <div class="text-wrap" v-if="item.author">
            <div class="tit">作者：</div>
            <div class="con" v-text="item.author"></div>
          </div>
          <div class="text-wrap" v-if="item.language">
            <div class="tit">语种：</div>
            <div class="con" v-text="item.language"></div>
          </div>
          <div class="text-wrap" v-if="item.press">
            <div class="tit">出版社：</div>
            <div class="con van-multi-ellipsis--l2" v-text="item.press"></div>
          </div>
          <div class="text-wrap" v-if="item.publishDate">
            <div class="tit">出版年：</div>
            <div
              class="con van-multi-ellipsis--l2"
              v-text="item.publishDate"
            ></div>
          </div>
          <div class="text-wrap" v-if="item.isbnNumber">
            <div class="tit">ISBN：</div>
            <div
              class="con van-multi-ellipsis--l2"
              v-text="item.isbnNumber"
            ></div>
          </div>
          <div class="text-wrap" v-if="item.insertTime">
            <div class="tit">捐赠时间：</div>
            <div class="con" v-text="item.insertTime"></div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import { getBookDonateList } from "@/api/common";
import { STATUS_CODE_OK } from "@/config";

export default {
  name: "BookDonation",
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      list: [],
      pageNo: 1,
      pageSize: 20,
    };
  },
  methods: {
    // 书籍查询
    async handleBookQuery(isRefresh = false) {
      if (isRefresh) {
        this.pageNo = 1;
        this.loading = true;
        this.finished = false;
      }
      let { data } = await getBookDonateList({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      });
      if (data.code === STATUS_CODE_OK) {
        this.refreshing = false;
        this.loading = false;
        this.finished = data.data.hasMore === "N" ? true : false;
        this.pageNo++;
        if (isRefresh) {
          this.list = data.data.pageInfo;
        } else {
          this.list = this.list.concat(data.data.pageInfo);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  background-color: #f7f8fa;
  .tab-wrap {
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    height: 58px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 666;
    border-bottom: 1px solid #eee;
    .tab-left {
      display: flex;
      align-items: center;
      .tab {
        color: #1282f4;
        padding: 8px 0;
        border: 1px solid #1282f4;
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        &.active {
          color: #fff;
          background-color: #1282f4;
        }
      }
    }
    .filter-wrap {
      display: flex;
      align-items: center;
      font-size: 16px;
      .filter {
        margin-left: 2px;
        font-size: 20px;
      }
    }
  }
  .list-wrap {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 666;
    overflow-y: auto;
    .item {
      background-color: #fff;
      margin-bottom: 10px;
      padding: 10px;
      &:last-child {
        margin-bottom: 0;
      }
      .text-wrap {
        padding-bottom: 5px;
        display: flex;
        .tit {
          color: #000;
          flex: none;
          &.all {
            flex: 1;
            width: 0;
            font-weight: bolder;
            padding-bottom: 2px;
            color: #333;
          }
        }
        .con {
          color: #777;
          flex: 1;
          width: 0;
        }
        &:last-child {
          padding-bottom: 0;
        }
      }
    }
  }
  .filter-pannel {
    width: 260px;
    background-color: #f7f8fa;
    padding-bottom: 60px;
    height: 100%;
    .filter-item-wrap {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 60px;
      overflow-y: auto;
      .filter-item {
        margin-bottom: 10px;
        background-color: #fff;
        padding: 0 10px 10px 10px;
        &:last-child {
          margin-bottom: 0;
        }
        .filter-title {
          color: #000;
          padding: 10px 0;
        }
        .filter-con {
          display: flex;
          flex-wrap: wrap;
          .year-wrap {
            display: flex;
            align-items: center;
            .arrow {
              margin-left: 3px;
            }
          }
          .btn {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #333;
            background-color: #eee;
            border-radius: 50px;
            min-width: 60px;
            padding: 0 10px;
            height: 30px;
            font-size: 12px;
            margin: 5px;
            &.active {
              background-color: #1282f4;
              color: #fff;
            }
          }
        }
      }
    }
    .filter-bottom {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      height: 60px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      .btn {
        padding: 6px 12px;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #f96e2f;
        background-color: #fff;
        border: 1px solid #f96e2f;
        min-width: 100px;
        &.btn-sure {
          background-color: #f96e2f;
          color: #fff;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
